import { render } from "./pos-company.vue?vue&type=template&id=bafcb87c&scoped=true"
import script from "./pos-company.vue?vue&type=script&lang=js"
export * from "./pos-company.vue?vue&type=script&lang=js"

import "./pos-company.vue?vue&type=style&index=0&id=bafcb87c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafcb87c"]])

export default __exports__